document.addEventListener("DOMContentLoaded", function() {
  // Only run on mobile screens
  if (window.innerWidth < 768) {
    // Select all menu blocks in the footer
    const menuBlocks = document.querySelectorAll('.footer__block--menu');

    menuBlocks.forEach(block => {
      const title = block.querySelector('.bold');
      
      if (title) {
        title.style.cursor = 'pointer';
        
        title.addEventListener('click', function() {
          // Check if this block is already open
          const isOpen = block.classList.contains('is-open');
          
          // Close all other menus first (Optional: remove this loop to allow multiple open)
          menuBlocks.forEach(b => b.classList.remove('is-open'));
          
          // Toggle the clicked one
          if (!isOpen) {
            block.classList.add('is-open');
          }
        });
      }
    });
  }
});


  class FAQItem extends HTMLElement {
  constructor() {
    super();
    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    this.question = this.querySelector(".faqrs-question");
    this.answer = this.querySelector(".faqrs-answer");
    if (this.question && this.answer) {
      this.question.addEventListener("click", this.handleToggle);
    }
  }

  disconnectedCallback() {
    if (this.question) {
      this.question.removeEventListener("click", this.handleToggle);
    }
  }

  handleToggle() {
    const isActive = this.classList.contains("faqrs-active");
    const allItems = document.querySelectorAll("faq-item");
    allItems.forEach(item => item.close());
    if (!isActive) {
      this.open();
    }
  }

  open() {
    this.classList.add("faqrs-active");
    this.answer.style.maxHeight = this.answer.scrollHeight + "px";
    this.question.setAttribute("aria-expanded", "true");
  }

  close() {
    this.classList.remove("faqrs-active");
    if(this.answer) {
        this.answer.style.maxHeight = null;
    }
    if(this.question) {
        this.question.setAttribute("aria-expanded", "false");
    }
  }
}
customElements.define("faq-item", FAQItem);
/* Variant slider centring moved to snippets/variant-picker.liquid (window.sonerVariantSlider). */

/* SÖNER (8 Oct 2026): when a shopper empties the cart, send them straight back to all watches
   (/collections/rectangular-watches, in their language/market) instead of leaving them on an empty page.
   How: every time the cart page shows real items we remember it for this browser tab. If the cart page then
   shows up empty (last item removed, the page reloads), or only the free travel case is left, we go to the
   collection. Someone who opens an empty cart without having had items in it this visit still sees the normal
   empty-cart page with its "Continue shopping" button. */
(function () {
  var path = window.location.pathname.replace(/\/$/, '');
  if (!/(^|\/)cart$/.test(path)) return;
  var KEY = 'soner_cart_had_items';
  function store(fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } }
  function run() {
    var section = document.querySelector('.shopify-section--main-cart');
    if (!section) return;
    var paidItems = section.querySelectorAll('.scart__item:not(.scart__item--gift)').length;
    if (paidItems > 0) {
      store(function (s) { s.setItem(KEY, '1'); });
      return;
    }
    var hadItems = store(function (s) { return s.getItem(KEY); }) === '1';
    if (!hadItems) return;
    store(function (s) { s.removeItem(KEY); });
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.replace(root + 'collections/rectangular-watches');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* SÖNER (13 Oct 2026): product page behaviour tracking, to learn which parts of the product page buyers use.
   1) Clarity: each action below is sent once per product page view as a Clarity custom event (pdp_size_guide,
      pdp_gallery, pdp_variant, pdp_engraving, pdp_specs, pdp_description, pdp_strap, pdp_faq, pdp_shipping,
      pdp_question, pdp_reviews, pdp_other_model, pdp_add_to_cart) and the running list is set as the Clarity tag
      "pdp_actions". In Clarity: filter recordings or the dashboard on a custom event, then compare the share that
      also has pdp_add_to_cart.
   2) Orders: the actions used during this visit (all product pages in this browser tab) are saved on the cart as
      the attribute "Product page actions" when something is added to the cart. It shows on the order in Shopify
      admin under Additional details, so orders can be grouped by what the buyer used.
   Clarity only loads after tracking consent; events made before that are queued and sent when Clarity is ready. */
(function () {
  if (!/\/products\//.test(window.location.pathname)) return;
  var KEY = 'soner_pdp_actions';
  var seen = {};
  var queue = [];
  function store(fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } }
  function visitActions() {
    var raw = store(function (s) { return s.getItem(KEY); });
    return raw ? raw.split(',').filter(Boolean) : [];
  }
  function flush() {
    if (typeof window.clarity !== 'function') return false;
    while (queue.length) { var a = queue.shift(); try { window.clarity.apply(null, a); } catch (e) {} }
    return true;
  }
  var tries = 0;
  var timer = setInterval(function () { tries++; if (flush() || tries > 90) clearInterval(timer); }, 2000);
  function clarityCall() { queue.push([].slice.call(arguments)); flush(); }
  function track(name) {
    if (seen[name]) return;
    seen[name] = true;
    clarityCall('event', 'pdp_' + name);
    var list = visitActions();
    if (list.indexOf(name) === -1) { list.push(name); store(function (s) { s.setItem(KEY, list.join(',')); }); }
    clarityCall('set', 'pdp_actions', Object.keys(seen).join(','));
  }
  function saveOnCart() {
    var list = visitActions();
    if (!list.length || !window.fetch) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Product page actions': list.join(', ') } })
    }).catch(function () {});
  }
  var ACCORDIONS = [
    ['specification', 'specs'], ['description', 'description'], ['strap', 'strap'],
    ['faq', 'faq'], ['shipping', 'shipping'], ['warranty', 'shipping']
  ];
  function textOf(el) { return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('product-gallery, .product-gallery')) { track('gallery'); return; }
    if (t.closest('[id*="soner_reviews"], .shopify-section--soner-reviews, [class*="soner-reviews"], .jdgm-widget, .jdgm-rev-widg, [id*="judgeme"]')) { track('reviews'); }
  }, { passive: true, capture: true });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.soner-sizechart-trigger')) { track('size_guide'); return; }
    if (t.closest('[data-soner-eng-open]')) { track('engraving'); return; }
    var head = t.closest('.faqrs-question, summary, button[aria-expanded], .accordion__toggle, [class*="faq"] button, [class*="faq"] [role="button"]');
    if (head) {
      var txt = textOf(head);
      for (var i = 0; i < ACCORDIONS.length; i++) {
        if (txt.indexOf(ACCORDIONS[i][0]) !== -1) { track(ACCORDIONS[i][1]); return; }
      }
    }
    var btn = t.closest('a, button');
    if (btn && textOf(btn).indexOf('need assistance') !== -1) { track('question'); return; }
    var link = t.closest('a[href*="/products/"]');
    if (link && link.closest('product-info, .product-info, .product, [id*="MainProduct"], [class*="main-product"]')) {
      var here = window.location.pathname.split('/products/')[1] || '';
      var there = (link.getAttribute('href') || '').split('/products/')[1] || '';
      if (there.split('?')[0] !== here.split('?')[0]) track('other_model');
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('variant-picker, .variant-picker') || /^option/i.test(t.name || '')) track('variant');
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    track('add_to_cart');
    clarityCall('upgrade', 'add_to_cart');
    setTimeout(saveOnCart, 1500);
  }, true);
})();

/* SÖNER (13 Oct 2026): collection filter tracking, to learn which filters shoppers use and whether they buy.
   1) Clarity: on collection pages every filter value used is sent once as a custom event, e.g.
      "filter_case_size", "filter_dial_colour", "filter_case_finish", "filter_movement_type", "filter_price",
      "sort_<value>", and the values are set as the Clarity tag "collection_filters" (e.g. "case_size:40 x 28 mm").
   2) Orders: the filters used during this visit are saved on the cart as the attribute "Collection filters used"
      when something is added to the cart, so orders can be grouped by filter use.
   The theme updates the URL when a filter changes, so the URL is read on load and after every URL change. */
(function () {
  var KEY = 'soner_filters_used';
  var queue = [];
  var seen = {};
  function store(fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } }
  function used() {
    var raw = store(function (s) { return s.getItem(KEY); });
    return raw ? raw.split('|').filter(Boolean) : [];
  }
  function flush() {
    if (typeof window.clarity !== 'function') return false;
    while (queue.length) { var a = queue.shift(); try { window.clarity.apply(null, a); } catch (e) {} }
    return true;
  }
  function clarityCall() { queue.push([].slice.call(arguments)); flush(); }
  var tries = 0;
  var timer = setInterval(function () { tries++; if (flush() || tries > 90) clearInterval(timer); }, 2000);

  function readUrl() {
    if (!/\/collections\//.test(window.location.pathname)) return;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var found = [];
    params.forEach(function (value, name) {
      if (!value) return;
      var m = name.match(/^filter\.p\.m\.[^.]+\.(.+)$/);
      if (m) { found.push([m[1], value]); return; }
      if (/^filter\.v\.price\./.test(name)) { found.push(['price', name.split('.').pop() + ' ' + value]); return; }
      if (/^filter\./.test(name)) { found.push([name.replace(/^filter\.(p|v)\./, '').replace(/\./g, '_'), value]); return; }
      if (name === 'sort_by') found.push(['sort', value]);
    });
    if (!found.length) return;
    var list = used();
    found.forEach(function (f) {
      var label = f[0] + ':' + f[1];
      if (!seen[f[0]]) { seen[f[0]] = true; clarityCall('event', f[0] === 'sort' ? 'sort_' + f[1] : 'filter_' + f[0]); }
      if (list.indexOf(label) === -1) list.push(label);
    });
    list = list.slice(-20);
    store(function (s) { s.setItem(KEY, list.join('|')); });
    clarityCall('set', 'collection_filters', list.join(', '));
  }
  /* 14 Oct 2026: clicks on the "Filter and sort" button (the fixed button on mobile, or any button that opens the
     filter drawer) are sent to Clarity as the event "filter_button" (once per page view) and saved with the visit
     as "panel:opened", so the monthly report can compare: opened the filters / applied a filter / bought. */
  var openedSent = false;
  document.addEventListener('click', function (e) {
    if (!/\/collections\//.test(window.location.pathname)) return;
    var t = e.target;
    if (!t || !t.closest || !t.closest('facet-floating-filter, [aria-controls="facets-drawer"]')) return;
    if (!openedSent) { openedSent = true; clarityCall('event', 'filter_button'); }
    var list = used();
    if (list.indexOf('panel:opened') === -1) {
      list.push('panel:opened');
      store(function (s) { s.setItem(KEY, list.join('|')); });
      clarityCall('set', 'collection_filters', list.join(', '));
    }
  }, true);

  ['pushState', 'replaceState'].forEach(function (fn) {
    var orig = window.history[fn];
    if (typeof orig !== 'function') return;
    window.history[fn] = function () {
      var r = orig.apply(this, arguments);
      setTimeout(readUrl, 0);
      return r;
    };
  });
  window.addEventListener('popstate', readUrl);
  readUrl();

  function saveOnCart() {
    var list = used();
    if (!list.length || !window.fetch) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Collection filters used': list.join(', ') } })
    }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    setTimeout(saveOnCart, 3000);
  }, true);
})();
